var map = {
	"./advanced_control.js": 83,
	"./alignment_control.js": 84,
	"./animation_preview_control.js": 85,
	"./background_image_control.js": 86,
	"./blog_control.js": 87,
	"./border_control.js": 88,
	"./carousel_control.js": 89,
	"./catalog_control.js": 90,
	"./color_control.js": 91,
	"./control.js": 0,
	"./countdown_control.js": 92,
	"./custom_block_control.js": 93,
	"./dimension_control.js": 94,
	"./gradient_control.js": 95,
	"./href_control.js": 96,
	"./iframe_control.js": 97,
	"./json_control.js": 45,
	"./link_control.js": 98,
	"./product_control.js": 99,
	"./richtext_control.js": 100,
	"./search_control.js": 47,
	"./search_products_control.js": 101,
	"./section_frames_control.js": 102,
	"./shadow_control.js": 103,
	"./src_control.js": 104,
	"./style_control.js": 46,
	"./submenu_control.js": 105,
	"./text_control.js": 106,
	"./text_format_control.js": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;